import styled from 'styled-components'

export const LoadingStatusContainer = styled.div`
  font-weight: bold;
  color: #fff;
`